export var FlagState;
(function (FlagState) {
    FlagState["DISABLED"] = "disabled";
    FlagState["ENABLED"] = "enabled";
})(FlagState || (FlagState = {}));
